<template>
  <header>
    <div class="main">
      <router-link to="/">
        <img id="big" src="@/assets/img/munster.jpg">
        <img id="small" src="@/assets/img/MunsterSmall2.png">
      </router-link>
      <app-nav class="nav"></app-nav>
    </div>
  </header>
</template>
<script>
import AppNav from '@/components/AppNav.vue';
export default {
  name: 'AppHeader',
  components: { AppNav },
};
</script>
<style lang="scss" scoped>
@import '../assets/css/definitions';

header {
  display: block;
  background: $color-bg;
  color: $color-acc;
  width: 100%;
  height: 200px;

  .main {
    position: relative;
    #big {
      position: absolute;
      left: 0;
      top: 20px;
      padding: 16px;
      width: 500px;
    }
    #small {
      visibility: hidden;
    }
    .nav {
      position: absolute;
      left: 375px;
      top: 125px;
      //bottom: 0;
    }
  }

  @media screen and (max-width: 1024px) {
    .main {
      position: relative;
      #big {
        visibility: hidden;
      }
      #small {
        visibility: visible;
        position: absolute;
        left: 20px;
        top: 25px;
        width: 150px;
      }
      .nav {
        position: absolute;
        top: 55px;
        right: 75px;
      }
    }
  }
}
</style>
